import { defineComponent, h } from 'vue';
export default defineComponent({
    name: 'VxeIcon',
    props: {
        name: String,
        roll: Boolean
    },
    emits: [
        'click'
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var clickEvent = function (evnt) {
            emit('click', { $event: evnt });
        };
        return function () {
            return h('i', {
                class: ["vxe-icon-".concat(props.name), props.roll ? 'roll' : ''],
                onClick: clickEvent
            });
        };
    }
});
